import React from 'react';
import { store } from '../../../../store';

const LinksSection = ({onOpen}) => {

  let arr = store.getState().links;
    return(arr.map((value,i) => 
  {
  	if(store.getState().activities.edit)  {
            return(
              <span
              onClick={() => onOpen(`${value.name}`)}
              onBlur={()=> onOpen('')}
              className={`fa fa-${value.name} socialicon`}></span>)
        }
     else {
     	return (<a href={value.link}
              className={`fa fa-${value.name} socialicon`} target="_blank" rel="noopener noreferrer"> </a>)
     }

            
  }))
}
export default LinksSection;